import { Spin } from 'antd';
import React, { lazy, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import AuthLayout from '../container/profile/authentication/Index';

const ExternalReviewProof = lazy(() => import('../container/externalReviewProof/ExternalReviewProof'));
const ExternalReviewImage = lazy(() => import('../container/externalReviewProof/ExternalReviewImage'));
// const NotFound = lazy(() => import('../../container/pages/404'));

const ExternalRoute = React.memo(() => {
  const { pathname } = useLocation();
  console.log('pathname', pathname);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route path="/approver/:proofId/token" element={<ExternalReviewProof />} />
        <Route path="/approver/externalReviewImage/:proofId/token" element={<ExternalReviewImage />} />
        <Route path="/commenter/:proofId/token" element={<ExternalReviewProof />} />
        <Route path="/commenter/externalReviewImage/:proofId/token" element={<ExternalReviewImage />} />
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </Suspense>
  );
});

export default AuthLayout(ExternalRoute);
